const ensureSlash = (url) => (url.endsWith('/') ? url : `${url}/`)

export default ensureSlash
